import Vue from 'vue'
import App from './App.vue'

import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css'
import 'vuesax/dist/vuesax.css';
Vue.use(Vuesax)

// Theme Configurations
import '../themeConfig.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Simple Line icon
import SimpleLineIcons from 'vue-simple-line'
Vue.component('simple-line-icons', SimpleLineIcons)

// Ion icon
require('@/assets/css/ionicons.css')

// Font Awesome icon
require('@/assets/css/fontawesome.css')

// Crypto icon
require('@/assets/css/cryptofont.css')

// materialdesign icon
require('@/assets/css/materialdesignicons.min.css')

// themify icon
require('@/assets/css/themify-icons.css')

// weather icon
require('@/assets/css/pe-icon-set-weather.min.css')

// flag icon
require('@/assets/css/flag-icon.min.css')

// icofont icon
require('@/assets/css/icofont.min.css')

// linearicons icon
require('@/assets/css/linearicons.css')

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
